import PropTypes from "prop-types";
import { ChatIcon } from "@circle-react/components/Chat/ChatIcon";

export const ChatButton = ({ communityMemberId }) => (
  <div className="community-member__chat-button">
    <div className="community-member__actions--desktop">
      <ChatIcon
        showIcon={false}
        buttonClass="btn btn-primary btn--chat"
        communityMemberId={communityMemberId}
      />
    </div>
  </div>
);

ChatButton.propTypes = {
  communityMemberId: PropTypes.number.isRequired,
};
